/* The shared vocabulary of every floating list: one recipe, several
   consumers (Select's panel, Command, the future DropdownMenu and
   FilterTrigger). Components add only their BEHAVIOUR-specific bits on
   top: highlight variant (focus: for Radix Select, aria-selected: for
   cmdk), positioning offsets, state machines.

   PANEL (the frosted popover): popover surface at 90% over
   the 8px backdrop blur, NO border (shadow-popover-sm paints its own
   hairline), 10px radius, 100ms, one step slower than controls.

   ITEM (the picker row): 14/20/400 label at full
   ink, px-2 py-1.5, rounded-lg (10-in-10 with the panel, no nesting
   math), 16px leading icons via the composing component's text span. */

/* The frost lives on a non-scrolling ::before layer: backdrop-filter on
   the scroller itself forces Chromium to re-composite the blur every
   scrolled frame (visible jank in long lists). The pseudo's backdrop is
   the static page behind the panel, so it caches; rows composite above. */
export const overlayPanelChrome =
  "text-popover-foreground shadow-popover-sm relative isolate rounded-lg duration-100 before:absolute before:inset-0 before:z-behind before:rounded-lg before:bg-popover-surface before:backdrop-blur-popover";

export const overlayItemChrome =
  "text-body-quiet relative flex w-full cursor-pointer items-center gap-2 rounded-lg px-2 py-1.5 outline-hidden select-none [&_svg]:shrink-0";
